import { render, staticRenderFns } from "./PrivacyPolicyModal.vue?vue&type=template&id=341e8def"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=341e8def&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports